import { Check, Beaker, Scale } from 'lucide-react';

const toFixed = (value, decimals = 2) => {
  return Number(value).toFixed(decimals);
};

export const receptionColumns = (
  employees = [],
  clients = [],
  garmentTypes = [],
  machines = [],
  washingPrograms = []
) => [
  
  {
    id: 'numeroLote',
    label: 'Lote',
    type: 'text',
    isForm: false,
    isFilter: true,
    width: '8%',
    render: (item) => item.numeroLote || 'N/A',
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    isForm: true,
    isFilter: true,
    width: '10%',
    options: [
      { value: 'pendiente', label: 'Pendiente' },
      { value: 'finalizado', label: 'Finalizado' }
    ],
    render: (item) => {
      const estado = item.estado || 'pendiente';
      let className = "px-2 py-0.5 rounded-full text-xs font-semibold ";
      
      if (estado === 'finalizado') {
        className += "bg-green-100 text-green-700 border border-green-200";
      } else {
        className += "bg-yellow-100 text-yellow-700 border border-yellow-200";
      }
      
      return <span className={className}>{estado.charAt(0).toUpperCase() + estado.slice(1)}</span>;
    },
  },
  {
    id: 'createdAt',
    label: 'Fecha Pesaje',
    type: 'date',
    isForm: true,
    isFilter: true,
    filterType: 'daterange',
    width: '12%',
    defaultToday: true,
    render: (item) => new Date(item.createdAt).toLocaleString(),
  },
  {
    id: 'empleado',
    label: 'Lavador',
    type: 'select',
    required: true,
    isFilter: true,
    width: '12%',
    options: employees.map(e => ({ value: e._id, label: `${e.nombre} ${e.apellido}` })),
    placeholder: 'Seleccione un lavador',
    render: (item) => {
      if (!item.empleado?.nombre) return 'N/A';
      const fullName = item.empleado.nombre;
      const truncated = fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[120px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'cliente',
    label: 'Nombre Cliente',
    type: 'select',
    required: true,
    isFilter: true,
    width: '12%',
    options: clients.map(c => ({ value: c._id, label: c.nombre })),
    placeholder: 'Seleccione un cliente',
    render: (item) => {
      if (!item.cliente?.nombre) return 'N/A';
      const fullName = item.cliente.nombre;
      const truncated = fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[120px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'tipoPrenda',
    label: 'Tipo Prenda',
    type: 'select',
    required: true,
    isFilter: true,
    width: '12%',
    options: garmentTypes.map(g => ({ value: g._id, label: g.nombre })),
    placeholder: 'Seleccione un tipo de prenda',
    render: (item) => {
      if (!item.tipoPrenda?.nombre) return 'N/A';
      const fullName = item.tipoPrenda.nombre;
      const truncated = fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[120px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },

  {
    id: 'maquina',
    label: 'Lavadora',
    type: 'select',
    required: true,
    isFilter: true,
    width: '10%',
    options: machines.map(m => ({ value: m._id, label: m.nombre })),
    placeholder: 'Seleccione una lavadora',
    render: (item) => {
      if (!item.maquina?.nombre) return 'N/A';
      const fullName = item.maquina.nombre;
      const truncated = fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[120px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'pesoKg',
    label: 'Peso Total (Kg)',
    type: 'number',
    required: true,
    isFilter: true,
    width: '8%',
  },
  {
    id: 'porcentajeRechazo',
    label: 'Porcentaje Rechazo',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.totalRechazoKilos || !item.pesoKg) return '-';
      return (
        <span className="text-rose-600 font-medium">
          {toFixed(item.totalRechazoKilos / item.pesoKg * 100, 2)}%
        </span>
      );
    },
  },
  {
    id: 'programaLavado',
    label: 'Programa Lavado',
    type: 'select',
    required: true,
    isFilter: true,
    width: '10%',
    options: washingPrograms.map(p => ({ 
      value: p._id, 
      label: `${p.numero_programa || ''} - ${p.nombre}` 
    })),
    placeholder: 'Seleccione un programa',
    render: (item) => {
      if (!item.programaLavado?.nombre) return 'N/A';
      // Mostrar número de programa y nombre si está disponible
      const numero = item.programaLavado.numero_programa || '';
      const nombre = item.programaLavado.nombre;
      const fullName = numero ? `${numero} - ${nombre}` : nombre;
      const truncated = fullName.length > 15 ? `${fullName.substring(0, 15)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[150px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },
  {
    id: 'kilosLimpios',
    label: 'Kilos Limpios',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.kilosLimpios) return '-';
      return (
        <span className="text-blue-600 font-medium">
          {item.kilosLimpios} kg
        </span>
      );
    },
  },

  {
    id: 'totalRechazoKilos',
    label: 'Kilos Rechazo',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '8%',
    render: (item) => {
      if (!item.totalRechazoKilos) return '-';
      
      // Calcular total de kilos rechazados
      const totalRechazo = item.totalRechazoKilos;
      
      return (
        <span className="text-rose-600 font-medium">
          {totalRechazo} kg
        </span>
      );
    },
  },
  {
    id: 'observaciones',
    label: 'Observaciones',
    type: 'textarea',
    isFilter: false,
    width: '12%',
  },
  {
    id: 'productosUsados',
    label: 'Productos Usados',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '12%',
    render: (item) => {
      const productos = Array.isArray(item.productosUsados) ? item.productosUsados : [];
      if (productos.length === 0) {
        return <span className="text-xs text-muted-foreground">—</span>;
      }
      const totalMl = productos.reduce((sum, p) => sum + (Number(p.cantidadMililitros) || 0), 0);
      const tooltipLines = productos
        .map(p => `• ${p?.producto?.nombre || 'Producto'}: ${Number(p.cantidadMililitros || 0).toFixed(2)} ml`)
        .join('\n');
      return (
        <span
          title={tooltipLines}
          className="inline-flex items-center gap-1 text-xs cursor-help"
        >
          <Beaker className="h-3.5 w-3.5 text-emerald-600" />
          <span className="px-1.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
            {productos.length} prod
          </span>
          <span className="text-emerald-700 font-mono">
            {totalMl.toFixed(1)} ml
          </span>
        </span>
      );
    },
  },
  {
    id: 'peso_total_factor_Carga',
    label: 'Peso Total (Factor Carga)',
    type: 'text',
    isForm: false,
    isFilter: false,
    width: '11%',
    render: (item) => {
      const value = Number(item.peso_total_factor_Carga);
      const capacidad = Number(item.capacidadAplicada);
      const factorCarga = Number(item.factorCargaAplicado);
      if (!Number.isFinite(value) || value === 0) {
        return <span className="text-xs text-muted-foreground">—</span>;
      }
      const tooltipLines = [
        `Capacidad de la lavadora: ${Number.isFinite(capacidad) ? capacidad : '?'} kg`,
        `Factor de carga del programa: ${Number.isFinite(factorCarga) ? factorCarga : '?'}`,
        `Cálculo: capacidad × 10 / factorCarga`,
        `Resultado: ${value.toFixed(2)} kg`,
      ].join('\n');
      return (
        <span
          title={tooltipLines}
          className="inline-flex items-center gap-1 text-xs cursor-help"
        >
          <Scale className="h-3.5 w-3.5 text-indigo-600" />
          <span className="px-1.5 py-0.5 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 font-mono">
            {value.toFixed(2)} kg
          </span>
        </span>
      );
    },
  },
  {

    id: 'empleado_finaliza',
    label: 'Lavador que finaliza',
    type: 'select',
    isForm: false,
    isFilter: false,
    width: '12%',
    options: employees.map(e => ({ value: e._id, label: `${e.nombre} ${e.apellido}` })),
    placeholder: 'Seleccione un lavador',
    render: (item) => {
      if (!item.empleado_finaliza?.nombre) return 'N/A';
      const fullName = item.empleado_finaliza.nombre;
      const truncated = fullName.length > 11 ? `${fullName.substring(0, 11)}...` : fullName;
      
      return (
        <span 
          title={fullName} 
          className="truncate inline-block max-w-[120px] cursor-help"
        >
          {truncated}
        </span>
      );
    },
  },

  {
    key: 'opciones',
    id: 'opciones',
    label: 'Opciones',
    width: '10%',
    actions: [
      {
        key: 'edit',
        icon: 'Edit',
        tooltip: 'Editar',
        className: 'text-green-400 hover:text-green-600',
        showWhen: (item) => item.estado !== 'finalizado'
      },
      {
        key: 'delete',
        icon: 'Trash',
        tooltip: 'Eliminar lote (solo administradores)',
        className: 'text-red-400 hover:text-red-600',
        // Los lotes solo los puede eliminar un administrador, sin importar si
        // ya fueron finalizados. `props.isAdmin` lo inyecta la página.
        showWhen: (item, props) => Boolean(props?.isAdmin)
      },
      {
        key: 'finalizar',
        icon: 'Check',
        tooltip: 'Finalizar Lavado',
        className: 'text-blue-500 hover:text-blue-700',
        showWhen: (item) => item.estado !== 'finalizado'
      },
      {
        key: 'verRechazos',
        icon: 'Eye',
        tooltip: 'Ver Rechazos',
        className: 'text-amber-500 hover:text-amber-700',
        showWhen: (item) => item.estado === 'finalizado' && item.rechazos && item.rechazos.length > 0
      },
      {
        key: 'print',
        icon: 'Printer',
        tooltip: 'Imprimir ticket Bluetooth',
        className: 'text-purple-500 hover:text-purple-700',
      }
    ],
  },
];

// Mapea cada recepción a las claves que usa `columnsExcel`
export const receptionDataMapper = (item) => ({
  numeroLote: item.numeroLote || 'N/A',
  fechaPesaje: new Date(item.createdAt).toLocaleString(),
  nombreLavador: item.empleado ? `${item.empleado.nombre} ${item.empleado.apellido}` : 'N/A',
  nombreCliente: item.cliente?.nombre ?? 'N/A',
  tipoPrenda: item.tipoPrenda?.nombre ?? 'N/A',
  cantidadPesada: item.pesoKg,
  lavadora: item.maquina?.nombre ?? 'N/A',
  programaLavado: item.programaLavado?.nombre ?? 'N/A',
  arrastre: item.arrastre,
  cloro: item.cloro,
  grasa: item.grasa,
  tintas: item.tintas,
  oxido: item.oxido,
  clorhexidina: item.clorhexidina,
  pegante: item.pegante,
  azul_de_metileno: item.azul_de_metileno,
  otro: item.otro,
  pesoKg: item.pesoKg,
  kilosHumedos: item.kilosHumedos,
  porcentajeHumedadAplicado: item.porcentajeHumedadAplicado,
  kilosLimpios: item.kilosLimpios,
  totalRechazoKilos: item.totalRechazoKilos,
  lavador: item.empleado ? item.empleado.nombre : 'N/A',
  observaciones: item.observaciones,
});

// Columnas para la exportación a Excel
export const columnsExcel = [
  { header: 'Lote', key: 'numeroLote', width: 15 },
  { header: 'Fecha Pesaje', key: 'fechaPesaje', width: 20 },
  { header: 'Lavador', key: 'lavador', width: 30 },
  { header: 'Nombre Cliente', key: 'nombreCliente', width: 30 },
  { header: 'Tipo de Prenda', key: 'tipoPrenda', width: 25 },
  { header: 'Total Limpios (Kg)', key: 'kilosLimpios', width: 20 },
  { header: 'Total Rechazo (Kg)', key: 'totalRechazoKilos', width: 20 },
  { header: 'Total Kilos (Kg)', key: 'pesoKg', width: 20 },
  { header: "Arrastre", key: 'arrastre',width: 20 },
  { header: "Cloro", key: 'cloro',width: 20 },
  { header: "Grasa", key: 'grasa',width: 20 },
  { header: "Tintas", key: 'tintas',width: 20 },
  { header: "Oxido", key: 'oxido',width: 20 },
  { header: "Clorhexidina", key: 'clorhexidina',width: 20 },
  { header: "Pegante", key: 'pegante',width: 20 },
  { header: "Azul de metileno", key: 'azul_de_metileno',width: 20 },
  { header: "Otro", key: 'otro',width: 20 },
  { header: 'Lavadora', key: 'lavadora', width: 20 },
  { header: 'Programa de Lavado', key: 'programaLavado', width: 25 },
  { header: 'Observaciones', key: 'observaciones', width: 40 },
];

